import { Calendar, Pen, Trash2 } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { Text } from "tamagui";
import { getDayJs } from "../../../core/dayJs";
import { Block } from "../../../ui/Block";
import { Body } from "../../../ui/Body";
import type { InfoRowItemProps } from "../../../ui/InfoRow";
import { PopoverConfirm } from "../../../ui/PopoverConfirm";
import { EditorRenderInline } from "../../../ui/YooptaEditor";
import type { BusinessModuleTemplateData } from "./types";

export const TemplateStepDataModuleUI: React.FC<{
  templateModule: BusinessModuleTemplateData;
  onDelete: (templateData: BusinessModuleTemplateData) => void;
  onEdit: (templateData: BusinessModuleTemplateData) => void;
}> = observer(({ templateModule, onDelete, onEdit }) => {
  const infoRowItems = useMemo<InfoRowItemProps[]>(() => {
    const extraItems: InfoRowItemProps[] = [];

    if ("settings" in templateModule && templateModule.settings?.offsetInDays) {
      extraItems.push({
        icon: Calendar,
        text: `${templateModule.settings?.offsetInDays} days offset`,
      });
    } else if (
      "settings" in templateModule &&
      templateModule.settings?.dateDue
    ) {
      extraItems.push({
        icon: Calendar,
        text: getDayJs(templateModule.settings.dateDue),
      });
    }

    return [
      ...extraItems,
      {
        icon: Pen,
        text: (
          <Text onPress={() => onEdit(templateModule)} cursor="pointer">
            Edit
          </Text>
        ),
      },
      {
        icon: Trash2,
        text: (
          <PopoverConfirm
            placement="top-start"
            onConfirm={() => {
              onDelete(templateModule);
            }}
          >
            <Text cursor="pointer">Delete</Text>
          </PopoverConfirm>
        ),
      },
    ];
  }, [templateModule, onEdit, onDelete]);

  return (
    <Block
      grouped
      icon={<Text>{templateModule.emoji}</Text>}
      infoRowItems={infoRowItems}
    >
      <Body>{templateModule.title}</Body>
      {templateModule.descriptionYooptaEditor && (
        <EditorRenderInline
          numberOfLines={1}
          value={templateModule.descriptionYooptaEditor}
        />
      )}
    </Block>
  );
});
